import { useSelector } from "react-redux";
import Nav from "../Components/Nav/Nav";
import { UidContext } from "../Components/App.Context";
import Thread from "../Components/Thread";
import NewPostForm from "../Components/Post/NewPostForm";
import { useContext, useState } from "react";
import Login from "./Login";
import Menu from "../Components/Nav/Menu";
import SupportsRapide from "../Components/SupportsRapide/SupportsRapide";
import TutoRapide from "../Components/TutoRapide/TutoRapide";
import Chatbot from "../Components/chatbot/Chatbot";

const Home = ({ socket }) => {
  const userData = useSelector((state) => state.userReducer);
  const uid = useContext(UidContext);
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      {uid && userData.isActif ? (
        <>
          <Nav socket={socket} />
          <div className="mainContainer">
            <Menu />
            <div className="centerBlock">
              {userData.isAdmin || userData.isReferent ? (
                <NewPostForm socket={socket} />
              ) : null}
              <Thread socket={socket} />
            </div>
            <div className="rightBlock">
              <SupportsRapide />
              <TutoRapide />

              <div className="quiContacter" onClick={toggle}>
                <Chatbot />
              </div>

              {/* <div className="bg-starwars" style={divStyle}>
                <div className="text-starwars">
                  <p>CHALLENGE truspilot</p>
                </div>
                <div className="sous-titre-starwars">
                  <p>[Résultats définitifs]</p>
                </div>
                <button className="button-starswars">
                  {" "}
                  <a
                    href="https://view.genial.ly/6569ecebd0d3fd00145bcfa2/presentation-challenge-avis-resultats-definitifs"
                    target="_blank"
                  >
                    Voir les Résultats{" "}
                  </a>
                </button>
              </div> */}
            </div>
          </div>
        </>
      ) : (
        <Login />
      )}
    </>
  );
};

export default Home;
